/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import familyLawTeaserCardSectionStyle from "./familyLawTeaserCardSectionStyle";
import iconDivorce from "../../../../assets/icons/familyLaw/IconDocumentSignpost";
import iconAlimony from "../../../../assets/icons/familyLaw/IconCalculator";
import iconInheritance from "../../../../assets/icons/familyLaw/IconDeath";
import iconFamily from "../../../../assets/icons/familyLaw/IconFamily";
import Container from "../../../Container/Container";
import Typography from "@mui/material/Typography";
import LinkedCardBox from "../../../LinkedCardBox/LinkedCardBox";
import { getPartnerSlugByIri } from "../../../../constants/partnerIris";
import type { PartnerIri } from "../../../../constants/partnerIris";

type FamilyLawTeaserCardSectionProps = {
  heading?: string;
  partner: PartnerIri;
};

const FamilyLawTeaserCardSection = ({ heading, partner }: FamilyLawTeaserCardSectionProps) => {
  const partnerSlug = getPartnerSlugByIri(partner) ?? "partner";
  const teaserCards = [
    {
      icon: iconDivorce,
      heading: "Trennung / Scheidung",
      link: `/lp/${partnerSlug}/scheidung`,
    },
    {
      icon: iconAlimony,
      heading: "Unterhalt",
      link: `/lp/${partnerSlug}/unterhalt`,
    },
    {
      icon: iconInheritance,
      heading: "Erbe / Todesfall",
      link: `/lp/${partnerSlug}/todesfall`,
    },
    {
      icon: iconFamily,
      heading: "Anderes Thema",
      link: `/lp/${partnerSlug}/familienrecht-beratung`,
    },
  ];

  return (
    <Container sx={familyLawTeaserCardSectionStyle.container}>
      {heading && (
        <Typography variant={"h2"} sx={familyLawTeaserCardSectionStyle.heading}>
          {heading}
        </Typography>
      )}
      <LinkedCardBox linkedCards={teaserCards} />
    </Container>
  );
};

export default FamilyLawTeaserCardSection;
